import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { ExpandIcon } from './Styles/Icons';
import { RootContainer, Container, FlexRow, FlexColumn, ButtonGroup, ButtonWithLoader, Accordion, AccordionSummary, AccordionDetails, TitleSection,
	TitleRow, Title, Subtitle, InputGroup, Password } from './Styles/Settings';

import { changeTile } from '../../actions/changeTile';
import { updatePassword } from '../../actions/userActions';
import { updateSuccessMessage, updateErrorMessage } from '../../actions/commonActions';

const AccordionIds = {
	LOGIN_DETAILS: 'login-details',
};

class Settings extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			expandLoginDetails: false,
			currentPassword: '',
			newPassword: '',
			confirmNewPassword: '',
			updatingPassword: false,
			error: { main: '' },
		};
	}

	componentDidMount() {
		if (this.props.tile !== 'SETTINGS') {
			this.props.changeTile('SETTINGS');
		}
		if (this.props.history.action === 'POP') {
			this.props.changeTile('SETTINGS');
		}
	}

	handleExpandClick = (accordionId, event) => {
		let { expandLoginDetails } = this.state;

		switch (accordionId) {
			case AccordionIds.LOGIN_DETAILS:
				this.setState({ expandLoginDetails: !expandLoginDetails });
				break;
			default:
				break;
		}
	};

	handleInput = (key, event, next = null) => {
		this.setState(
			{
				[key]: event.target.value,
				error: { ...this.state.error, [key]: '' },
			},
			next
		);
	};

	handleSave = async (event) => {
		let { currentPassword, newPassword, confirmNewPassword } = this.state;

		let error = {};
		if (currentPassword === undefined || currentPassword === '') {
			error['currentPassword'] = 'Current password cannot be empty.';
		}
		if (newPassword === undefined || newPassword === '') {
			error['newPassword'] = 'New password cannot be empty.';
		}
		if (confirmNewPassword === undefined || confirmNewPassword === '') {
			error['confirmNewPassword'] = 'Please confirm the new password.';
		}
		if (newPassword && confirmNewPassword && newPassword !== confirmNewPassword) {
			error['newPassword'] = "New passwords don't match, please enter again.";
		}

		if (Object.keys(error).length) {
			this.setState({ error: error });
			this.props.updateErrorMessage(true, 'Clear errors before saving.');
			return;
		}

		this.setState({ updatingPassword: true }, async () => {
			await this.props.updatePassword(currentPassword, newPassword);
			this.setState({ updatingPassword: false }, () => {
				this.props.updateSuccessMessage(true, 'Password updated.');
			});
		});
	};

	render() {
		let { error, expandLoginDetails, currentPassword, newPassword, confirmNewPassword, updatingPassword } = this.state;

		return (
			<RootContainer>
				<Helmet>
					<title>Seller Portal | Settings</title>
				</Helmet>

				<TitleSection>
					<TitleRow style={{ flexWrap: 'wrap' }}>
						<FlexColumn style={{ flex: 3 }}>
							<Title>Settings</Title>
						</FlexColumn>
					</TitleRow>
				</TitleSection>

				<Container>
					<Accordion
						expanded={expandLoginDetails}
						onChange={(e) => {
							this.handleExpandClick(AccordionIds.LOGIN_DETAILS, e);
						}}
					>
						<AccordionSummary expandIcon={<ExpandIcon />}>
							<Subtitle>Change Password</Subtitle>
						</AccordionSummary>

						<AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
							<FlexRow
								style={{ gap: '1rem' }}
								responsive='1200px'
							>
								<InputGroup
									label='Current Password'
									markRequired={true}
									error={error && error.currentPassword}
								>
									<Password
										name='current-password'
										placeholder='Enter current password'
										value={currentPassword}
										onChange={(e) => {
											this.handleInput('currentPassword', e);
										}}
										error={error && error.currentPassword}
									/>
								</InputGroup>

								<InputGroup
									label='New Password'
									markRequired={true}
									error={error && error.newPassword}
								>
									<Password
										name='new-password'
										placeholder='Enter new password'
										value={newPassword}
										onChange={(e) => {
											this.handleInput('newPassword', e);
										}}
										error={error && error.newPassword}
									/>
								</InputGroup>

								<InputGroup
									label='Confirm New Password'
									markRequired={true}
									error={error && error.confirmNewPassword}
								>
									<Password
										name='confirm-new-password'
										placeholder='Confirm new password'
										value={confirmNewPassword}
										onChange={(e) => {
											this.handleInput('confirmNewPassword', e);
										}}
										error={error && error.confirmNewPassword}
									/>
								</InputGroup>
							</FlexRow>

							<FlexRow
								style={{ marginTop: '1rem' }}
								responsive='1200px'
							>
								<ButtonGroup alignRight>
									<ButtonWithLoader
										primary
										loading={updatingPassword}
										onClick={(e) => {
											this.handleSave(e);
										}}
									>
										Update Password
									</ButtonWithLoader>
								</ButtonGroup>
							</FlexRow>
						</AccordionDetails>
					</Accordion>
				</Container>
			</RootContainer>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		tile: state.tiles.tile,
		supplier: state.supplier.supplier,
	};
};

const mapDispatchToProps = {
	updateErrorMessage,
	updateSuccessMessage,
	changeTile,
	updatePassword,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Settings));
